import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncCircuitList = lazy(() => import('~/containers/CircuitList'));

export default [
  <Route path="/circuits" key="/circuits">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncCircuitList />
    </Suspense>
  </Route>,
];
